import { ref } from 'vue'

export const showSelectedOrder = ref(false)
